import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFont } from "../../contexts/FontContext/FontContext";
import { Helmet } from "react-helmet-async";
import LogoWrapper from "../LogoWrapper/LogoWrapper";
import TextInput from "../TextInput/TextInput";
import BackButton from "../BackButton/BackButton";
import styles from "./SignUp.module.css";
import { validateEmail, validateUsernameOrPassword } from "../utils/common";
import axios from "axios";

const SignUp = ( { csrfToken } ) => {
	const navigate = useNavigate();
	const [newUsername, setNewUsername] = useState('');
	const [newEmail, setNewEmail] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
	const [logisticsProviderCode, setLogisticsProviderCode] = useState('');
	const [error, setError] = useState('');
	//determines which field border to highlight red when there are errors.
	const [fieldErrors, setFieldErrors] = useState({
		usernameError: false,
		emailError: false,
		passwordError: false,
		passwordConfirmError: false,
	});
	const fontSchemes = useFont();    
    const fontFamilyOne = fontSchemes.scheme_one;
    const fontFamilyThree = fontSchemes.scheme_three; 

	const differentUsernameAndPassword = (username, password) => { return username !== password; }

	const validateForm = () => {
		var error = null; 
		let tempErrors = {
			usernameError: false,
			emailError: false,
			passwordError: false,
			passwordConfirmError: false,
		};
		if (!validateUsernameOrPassword(newUsername)) { 
			error = "Username must be a minimum of 8 characters long and contain at least one number and one letter."; 
			tempErrors.usernameError = true;
		} else if (!validateEmail(newEmail)) { 
			error = "Invalid email format."; 
			tempErrors.emailError = true;
		} else if (!validateUsernameOrPassword(newPassword)) { 
			error = "Password must be a minimum of 8 characters long and contain at least one number and one letter."; 
			tempErrors.passwordError = true;
		} else if (!differentUsernameAndPassword(newUsername, newPassword)) { 
			error = "Username and password must be different."; 
			tempErrors.passwordError = true;
		} else if (newPasswordConfirm !== newPassword) { 
			error = "Passwords do not match."; 
			tempErrors.passwordConfirmError = true;
		}
		setError(error);
		setFieldErrors(tempErrors);
	    return error === null; // return true if no errors
	};

	const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
        const userData = {
            username: newUsername,
            email: newEmail,
            password: newPassword,
            confirm_password: newPasswordConfirm,
            logistics_provider_code: logisticsProviderCode
        };
        try {
            console.log("Sending user data to server:", userData);
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await axios.post(`${apiUrl}/api/signup/`, userData, {
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken 
                },
                withCredentials: true,  // To ensure cookies are sent with the request
            });
            console.log("Success:", response.data);
            navigate("/confirmation_link_sent", { state: { email: newEmail } });
        } catch (error) {
            if (error.response) {
                // Check for username or email errors in the response
                let errorMessage = "";
                if (error.response.data.username) { errorMessage = error.response.data.username[0]; } // Grabbing the first username error 
                else if (error.response.data.email) { errorMessage = error.response.data.email[0]; } // Grabbing the first email error  
                else { errorMessage = "An unknown error occurred"; }                
                setError(errorMessage);
            } else { setError("An error occurred. Please try again."); }
        }
    }
};

	return (
		<div className={styles.signup_container}>
			<Helmet>
	        	<title>Sign up</title>
	        </Helmet>
			<LogoWrapper class_={styles.signup_logo} src={`${process.env.PUBLIC_URL}/images/partial_logo.png`} />
			<p className={`titles ${styles.create_account_title} ${fontFamilyOne}`}>Create a new account.</p>
			{/* if error exists, show error; otherwise, show the requirements */}
			<div className={`validation_wrapper ${styles.signup_validation_wrapper}`}>
				<p className={error ? "error_message" : `${styles.create_account_instructions} ${styles.requirements} ${fontFamilyOne}`}>{error || "Username and password must be different and contain"}</p>
			</div>
			{!error && (
				<ul className={`${styles.requirements} ${styles.requirements_list} ${fontFamilyThree}`}>
	                <li>at least 8 characters</li>
	                <li>a number and a letter</li>
	            </ul>
			)}
            <form className={styles.signup_form} onSubmit={handleSubmit}>
            	<div className="required_field">
            		<p className="asterisk">*</p>
					<TextInput inputType={"new_username"} value={newUsername} onChange={(e) => setNewUsername(e.target.value)} required error={fieldErrors.usernameError} />
				</div>
				<div className="required_field">
					<p className="asterisk">*</p>
					<TextInput inputType={"new_email"} value={newEmail} onChange={(e) => setNewEmail(e.target.value)} required error={fieldErrors.emailError} />
				</div>
				<div className="required_field">
					<p className="asterisk">*</p>
					<TextInput inputType={"password"} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required error={fieldErrors.passwordError} />
				</div>
				<div className="required_field">
					<p className="asterisk">*</p>
					<TextInput inputType={"confirm_password"} value={newPasswordConfirm} onChange={(e) => setNewPasswordConfirm(e.target.value)} required error={fieldErrors.passwordConfirmError} />
				</div>
				<div>
					 <p style={{ marginLeft: "7px" }}> </p>
					<TextInput inputType={"logistics_provider_code"} value={logisticsProviderCode} onChange={(e) => setLogisticsProviderCode(e.target.value)} />
				</div>
				<button className={`login_buttons ${styles.submit_signup} ${fontFamilyOne}`} type="submit">Submit</button>
			</form>
			<BackButton button_id={styles.signup_back_button} image_id={styles.signup_back_button_arrow} />
		</div>
	);
};

export default SignUp;

